import React from "react";
import { View } from "react-native";
import { Text } from "react-native-paper";
import { format } from "date-fns";
import packageJson from "../../package.json";
import deployInfo from "../config/deploy-info.json";

export const VersionDisplay = () => {
  const version = packageJson.version;
  const formattedDate = deployInfo.lastDeployDate
    ? format(new Date(deployInfo.lastDeployDate), "MMM d, yyyy HH:mm")
    : null;

  return (
    <View
      style={{
        padding: 16,
        borderTopWidth: 1,
        borderTopColor: "#e0e0e0",
        marginTop: "auto",
      }}
    >
      <Text style={{ textAlign: "center", color: "#666" }}>
        Version {version}
      </Text>
      {formattedDate && (
        <Text
          style={{
            textAlign: "center",
            color: "#666",
            fontSize: 12,
            marginTop: 4,
          }}
        >
          Deployed: {formattedDate}
        </Text>
      )}
    </View>
  );
};
